import * as React from 'react';
import { View, StyleProp, ViewStyle } from 'react-native';
import Svg, { Path } from 'react-native-svg';

const ForumPostsCountSvg = React.memo(
    (props: {
        size?: number;
        primaryColor?: string;
        containerStyle?: StyleProp<ViewStyle>;
    }) => {
        const size = props.size ?? 14;
        const width = size;
        const height = (size * (18/14));
// width={size}
//       height={size * (30 / 47)}
//       viewBox="0 0 47 30"
        return (
            <View style={props.containerStyle}>
                <Svg
                    width={width}
                    height={height}
                    viewBox="0 0 14 18"
                    fill="none"
                    {...props}
                >
                    <Path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M1.216 0H8.43v4.96c0 .187.15.338.337.338H14V16.1c0 .332-.137.636-.357.857l-.003.003c-.22.22-.523.355-.855.355H1.215c-.334 0-.638-.136-.858-.356A1.212 1.212 0 010 16.099V1.215C0 .881.137.577.357.357.577.137.88 0 1.216 0zm7.89.075c.031.021.06.046.084.074l4.618 4.474H9.106V.075zM3.088 14.194a.338.338 0 110-.676h7.824a.338.338 0 010 .676H3.088zm0-2.582a.338.338 0 110-.675h7.702a.338.338 0 110 .675H3.088zm0-2.582a.338.338 0 110-.675H9.32a.338.338 0 010 .675H3.088zm0-2.582a.338.338 0 110-.676h3.48a.338.338 0 110 .676h-3.48zm0-2.582a.338.338 0 110-.675h1.874a.338.338 0 110 .675H3.088z"
                        fill={props.primaryColor ?? '#F35E2E'}
                    />
                </Svg>
            </View>
        );
    },
);

ForumPostsCountSvg.displayName = 'ForumPostsCountSvg';

export { ForumPostsCountSvg };
